import React from 'react'
import gql from 'graphql-tag'
import _ from 'lodash'
import {
  Query
} from 'react-apollo'

import apolloClient from '../../../services/ApolloClient'
import ResearchCards from './ResearchCards'
import GraphqlQuery from '../../molecules/GraphqlQuery'

const STATE = gql`
  query ResearchCardsContainerState {
    research @client {
      selectedCategories
      selectedTheme {
        id
        name
      }
      selectedProducts
      selectedMeasurementUnit
    }
  }
`

const GET_SURVEY_IDS = gql`
  query ResearchCardContainerGetSurveyIds($id: Int!) {
    surveyByThemes(id: $id) {
      id
      name: nome
    }
  }
`

const QUERY = gql`
  query ResearchCardsContainerQuery(
    $themeId: Int!,
    $categoryIds: [Int!] = [0],
    $productIds: [Int!] = [0],
    $surveyIds: [Int!] = [0]
  ) {
    categoriesByTheme(theme_id: $themeId) {
      id
      name: nome
    }
    productsByCategories(category_ids: $categoryIds, survey_ids: $surveyIds) {
      id
      name: nome
    }
    measurementByTheme(id: $themeId, product_ids: $productIds) {
      id
      name: nome
      translate_key
    }
  }
`

export default class ResearchCardsContainer extends React.PureComponent {
  handleSelectedCategoriesChange = (selectedCategories) => {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedCategories
        }
      }
    })
  }

  handleSelectedProductsChange = (selectedProducts) => {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedProducts
        }
      }
    })
  }

  handleSelectedMeasurementUnitChange = (selectedMeasurementUnit) => {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedMeasurementUnit
        }
      }
    })
  }

  generateItems(list, nameField, valueField) {
    return list.map((element) => ({
      name: element[nameField],
      value: element[valueField]
    }))
  }

  renderComponent = ({ research }) => (
    <GraphqlQuery
      query={ GET_SURVEY_IDS }
      variables={{ id: this.props.selectedTheme.id }}
    >
      {({ surveyByThemes }) => (
        <Query
          query={ QUERY }
          variables={{
            themeId: this.props.selectedTheme.id,
            categoryIds: research.selectedCategories,
            productIds: research.selectedProducts,
            surveyIds: _.map(surveyByThemes, 'id')
          }}
        >
          {({ error, loading, data }) => {
            if (error) {
              return null
            }

            let categoriesByTheme = data.categoriesByTheme || []
            let productsByCategories = data.productsByCategories || []
            let measurementByTheme = data.measurementByTheme || []

            return (
              <ResearchCards
                categoriesCardProps={{
                  items: this.generateItems(categoriesByTheme, 'name', 'id'),
                  onChange: this.handleSelectedCategoriesChange,
                  value: research.selectedCategories,
                  loading: loading && _.isEmpty(categoriesByTheme)
                }}
                productsCardProps={{
                  items: this.generateItems(productsByCategories, 'name', 'id'),
                  onChange: this.handleSelectedProductsChange,
                  value: research.selectedProducts,
                  loading: loading && _.isEmpty(productsByCategories),
                  hasBaseItem: true
                }}
                measurementUnitsCardProps={{
                  items: this.generateItems(measurementByTheme, 'translate_key', 'id'),
                  onChange: this.handleSelectedMeasurementUnitChange,
                  value: research.selectedMeasurementUnit,
                  loading: loading && _.isEmpty(measurementByTheme)
                }}
              />
            )
          }}
        </Query>
      )}
    </GraphqlQuery>
  )

  render() {
    if (!this.props.selectedTheme) {
      return (
        <ResearchCards />
      )
    }

    return (
      <React.Fragment>
        <GraphqlQuery query={ STATE }>
          { this.renderComponent }
        </GraphqlQuery>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchCards/ResearchCards.container.js